import type { SelectProps } from 'antd';

export const CUSTOM_DIMENSION = 'Custom';
export const TAG_KEY = 'TAG_KEY';
export const DIMENSION_UPDATE_FAIL = 'Dimension update failed due to an unexpected error';
export const DIMENSION_CREATION_FAIL = 'Dimension creation failed due to an unexpected error';
export const DIMENSION_CREATION_FAIL_GENERAL =
  'Dimension creation failed due to an unexpected error';
export const DIMENSION_REQUIRED_ERROR = 'Dimension name is required!';
export const CUSTOM_NAME_REQUIRED_ERROR = 'Custom Name is required';
export const TAG_KEY_REQUIRED_ERROR = 'Tag key is required';
export const DIMENSION_NOT_EXIST = 'Selected dimension does not exist';
export const DIMENSION_TAG_DUPLICATION = (dimensionTag: string) =>
  `Dimension tags are duplicated: ${dimensionTag}`;
export const DIMENSION_NAME_DUPLICATION = (dimensionName: string) =>
  `Dimension names duplicated: ${dimensionName}`;
export const DIMENSION_EDIT_CONFIRM: [string, string] = [
  'Confirm edit?',
  'Are you sure you want to edit this item?',
];

export const DIMENSION_EXCEED_ERROR = 'dimension count should not be over';
export const DIMENSION_PAGE_SIZE = 50;
export const OPTIONS: SelectProps['options'] = [
  { value: 'ei', label: 'Video' },
  { value: 'ai', label: 'Ads' },
];
export const BANNED_TAGS: string[] = [
  'VIEWER_ID',
  'c3.viewer.id',
  'CLIENT_ID',
  'VSF_ERROR',
  'VPF_ERROR',
  'VSF_BUSINESS_ERROR',
  'VSF_TECH_ERROR',
  'VPF_BUSINESS_ERROR',
  'VPF_TECH_ERROR',
  'AD_ERROR',
  'ASF_ERROR',
  'APF_ERROR',
  'TAG',
];

export const INVALID_TAG_ERROR = `This is a Special Tag that already exists in Filter Builder's Dimension drop-down. It cannot be saved as a regular dimension.`;

export const REMOVE_TEXT = `
Conviva will stop computing data for this dimension immediately after your confirmation.
Please make sure that all the stakeholders are informed of this action in advance as this dimension will be removed from all the dashboards including AI Alerts.
Do you want to continue?`;
export const ADD_TEXT = `Conviva will start computing data for this dimension after your confirmation. Do you want to continue?`;
export const CHANGE_NAME_TEXT = (oldName: string, newName: string) =>
  `Do you want to change the name of this dimension from "${oldName}" to "${newName}"?`;
export const LEGACY = 'Legacy';
export const LEGACY_TEXT = 'Dimension name should not contain "Legacy"';
